import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientSaveGlobalFinancialMonitoringPartTwoMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveGlobalFinancialMonitoringPartTwoParam } from 'api/types/params';

import { parseLegalClient } from './helpers';
import { parseLegalClientSaveGlobalFinancialMonitoringPartTwoParam } from './helpers/parseLegalClientSaveGlobalFinancialMonitoringPartTwoParam';

export const useLegalClientSaveGlobalFinancialMonitoringPartTwo = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveGlobalFinancialMonitoringPartTwoMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClient ? parseLegalClient(data.legalClient) : undefined,
    loading,
    error,
    saveFinancialMonitoring: useCallback(
      async (
        id: string,
        params: LegalClientSaveGlobalFinancialMonitoringPartTwoParam
      ) => {
        const res = await handle({
          variables: {
            id,
            input:
              parseLegalClientSaveGlobalFinancialMonitoringPartTwoParam(params),
          },
        });
        return res.data?.legalClient
          ? parseLegalClient(res.data.legalClient)
          : undefined;
      },
      [handle]
    ),
  };
};
